import { Badge, cn } from '@blink/ui';
import { filsToAed } from '@blink/shared';
import { useI18n } from '@/i18n';
import type { CourierStatus } from '@/lib/api';
import type { LiveState } from '@/lib/live';

const STATUS_TONE: Record<CourierStatus, 'info' | 'teal' | 'purple' | 'warning'> = {
  ASSIGNED: 'info',
  OUT_FOR_DELIVERY: 'teal',
  IN_TRANSIT: 'purple',
  ON_HOLD: 'warning',
};

/** loaded: every piece is in the vehicle, waiting only for Start route */
export function StatusBadge({ status, loaded }: { status: CourierStatus; loaded?: boolean }) {
  const { t } = useI18n();
  if (loaded && status === 'ASSIGNED') return <Badge variant="success">{t.status.LOADED}</Badge>;
  return <Badge variant={STATUS_TONE[status]}>{t.status[status]}</Badge>;
}

/** "AED 125.50" */
export function aed(fils: number) {
  return `AED ${filsToAed(fils)}`;
}

/** Small dot in the header: live updates on or off. */
export function LiveDot({ state }: { state: LiveState }) {
  const { t } = useI18n();
  return (
    <span className="flex items-center gap-1.5 text-xs text-sidebar-foreground" data-testid="live-state" data-state={state}>
      <span className={cn('h-2 w-2 rounded-full', state === 'live' ? 'bg-emerald-400' : state === 'offline' ? 'bg-red-400' : 'bg-amber-300')} />
      {t.live[state]}
    </span>
  );
}
